import { SearchMaskGroupType, SearchMaskInputType, store, websiteActions } from 'ltur-state-engine';
import Vue from 'vue-ltur';
import BodyScrollLock from 'static-components/src/body-scroll-lock';
var Modal = /** @class */ (function () {
    function Modal() {
    }
    Modal.toggleFlyout = function (searchMaskGroupType, htmlId) {
        var flyouts = Modal.fetchingFlyouts();
        var musterTriggerToggle = true;
        for (var flyoutsIndex = 0; flyoutsIndex < flyouts.length; flyoutsIndex++) {
            var flyout = flyouts[flyoutsIndex];
            var linkTriggerElement = document.querySelector('.c-searchbox-link[data-flyout-id="' + flyout.id + '"]');
            if (!Modal.isCalendar(searchMaskGroupType, htmlId)) {
                Modal.closeHandlingForCalendar(flyout);
            }
            musterTriggerToggle = Modal.closeHandlingForTravellers(flyout);
            if (musterTriggerToggle && flyout.id !== htmlId) {
                flyout.className
                    = flyout.className
                        .replace(/(?:^|\s)is-active(?!\S)/, '');
                if (linkTriggerElement) {
                    linkTriggerElement.classList.remove('is-active');
                }
            }
            if (!musterTriggerToggle) {
                break;
            }
        }
        BodyScrollLock.toggleBodyScrollPosition();
        return musterTriggerToggle;
    };
    Modal.closeHandlingForFlyout = function (flyout, setBodyScrollClass) {
        if (setBodyScrollClass === void 0) { setBodyScrollClass = true; }
        Modal.closeHandlingForCalendar(flyout);
        var mustClose = Modal.closeHandlingForTravellers(flyout);
        var htmlId = flyout.getAttribute('id');
        if (mustClose) {
            flyout.className
                = flyout.className
                    .replace(/(?:^|\s)is-active(?!\S)/, '');
            var searchBoxLink = document.querySelector('.c-searchbox-link[data-flyout-id="' + htmlId + '"]');
            if (searchBoxLink) {
                searchBoxLink.classList.remove('is-active');
            }
            if (!document.querySelector('.c-flyout.is-active')) {
                if (setBodyScrollClass) {
                    BodyScrollLock.toggleBodyScrollPosition();
                }
            }
        }
    };
    Modal.clickHandlerBody = function (event) {
        if (!event.flyoutOpened && Modal.isFlyoutOpen() && Modal.isOutsideOfFlyoutWindow(event.target)) {
            var flyouts = Modal.fetchingFlyouts();
            for (var flyoutsIndex = 0; flyoutsIndex < flyouts.length; flyoutsIndex++) {
                if (flyouts[flyoutsIndex].className.indexOf('c-flyout--disable-events') === -1) {
                    Modal.closeHandlingForFlyout(flyouts[flyoutsIndex]);
                }
            }
        }
    };
    Modal.registerFlyoutClosingListener = function () {
        document.getElementsByTagName('body')[0]
            .addEventListener('click', Modal.clickHandlerBody);
    };
    Modal.closeHandlingForTravellers = function (calendarFlyout) {
        if (calendarFlyout.id.search(new RegExp(SearchMaskInputType.TRAVELLERS, "i")) !== -1) {
            var searchMaskGroupType = SearchMaskGroupType[calendarFlyout.dataset.searchmaskgrouptype];
            var lturState = store.getState();
            var searchMaskBundle = lturState.websiteState.searchMask.searchMaskBundle;
            var inputValue = searchMaskBundle.groups[searchMaskGroupType].inputs[SearchMaskInputType.TRAVELLERS].confirmedValue;
            var travelPeriodInputValue = inputValue.value;
            var searchButton = document.getElementById(searchMaskGroupType + '_searchButton');
            if (travelPeriodInputValue.hasError && Array.isArray(travelPeriodInputValue.hasError) && travelPeriodInputValue.hasError.length > 0) {
                Vue.dispatch(websiteActions.changeShowErrorSearchMaskTravellers(searchMaskGroupType, travelPeriodInputValue.errorExists));
            }
            if (searchButton !== null) {
                searchButton.disabled = travelPeriodInputValue.errorExists;
            }
            return !travelPeriodInputValue.errorExists;
        }
        return true;
    };
    Modal.closeHandlingForCalendar = function (calendarFlyout) {
        if (calendarFlyout.id.search(new RegExp(SearchMaskInputType.TRAVEL_PERIOD, "i")) !== -1) {
            var searchMaskGroupType = SearchMaskGroupType[calendarFlyout.dataset.searchmaskgrouptype];
            var lturState = store.getState();
            var searchMaskBundle = lturState.websiteState.searchMask.searchMaskBundle;
            var inputValue = searchMaskBundle.groups[searchMaskGroupType].inputs[SearchMaskInputType.TRAVEL_PERIOD].confirmedValue;
            var travelPeriodInputValue = inputValue.value;
            if (travelPeriodInputValue.datePickerIsOpen) {
                Vue.dispatch(websiteActions.closeCalendar(searchMaskGroupType));
            }
        }
    };
    Modal.fetchingFlyouts = function () {
        var modalContainer = document.getElementById('modal-container');
        var flyouts = modalContainer.getElementsByClassName('c-flyout--searchbox');
        return flyouts;
    };
    Modal.isOutsideOfFlyoutWindow = function (element) {
        return ((element.closest('.c-flyout--searchbox') === null
            && element.closest('.c-searchbox-grid__item') === null
            && element.closest('.c-searchbox-link__bottom') === null
            && element.closest('.c-searchbox-link__wrapper') === null
            && element.closest('.c-last-minute__selectbox') === null
            && !element.classList.contains('.c-flyout--searchbox'))
            || element.classList.contains('c-flyout--disable-events'));
    };
    Modal.isCalendar = function (searchMaskGroupType, htmlId) {
        return (searchMaskGroupType + '_' + SearchMaskInputType.TRAVEL_PERIOD) === htmlId;
    };
    Modal.isFlyoutOpen = function () {
        return !!document.querySelector('.c-flyout--searchbox.is-active');
    };
    Modal.isInsidePriceRangeSlider = function (searchMaskGroupType, element) {
        return (element.closest('#' + searchMaskGroupType + '_' + SearchMaskInputType.PRICE_RANGE) !== null);
    };
    Modal.closingFlyoutsFromAnyElement = function (setBodyScrollClass) {
        if (setBodyScrollClass === void 0) { setBodyScrollClass = true; }
        var flyouts = Modal.fetchingFlyouts();
        for (var flyoutsIndex = 0; flyoutsIndex < flyouts.length; flyoutsIndex++) {
            Modal.closeHandlingForFlyout(flyouts[flyoutsIndex], setBodyScrollClass);
        }
    };
    return Modal;
}());
export default Modal;
export function createSearchMaskModalIdString(searchMaskModalID) {
    return searchMaskModalID.searchMaskGroupType + '_' + searchMaskModalID.searchMaskInputType;
}
